import { API } from 'api/config'
import {
	OPTRequest,
	OTPResponse,
	SingigResponse,
	SinginRequest
} from 'interfaces'
import { captureErrorSentry, SentryEvents, SentrySections } from 'utils'

export const singin = async (
	body: SinginRequest
): Promise<SingigResponse | null> => {
	let res = null as SingigResponse | null
	await API()
		.post(`/auth/signin`, body)
		.then(response => {
			res = response.data
		})
		.catch(error => {
			captureErrorSentry({
				section: SentrySections.AUTHENTICATION,
				event: SentryEvents.SIGNIN_ERROR,
				error,
				extra: {
					payload: body
				}
			})
			if (error.response.data.errors) {
				res = { detail: error.response.data.errors[0].msg }
			} else if (error.response.data.detail) {
				res = { detail: error.response.data.detail }
			} else {
				res = { detail: error.response.data.detail.error }
			}
		})
	return res
}

export const requestOpt = async (
	body: OPTRequest
): Promise<OTPResponse | null> => {
	let res = null as OTPResponse | null
	await API()
		.post(`/auth/validate_request_otp`, body)
		.then(response => {
			res = response.data
		})
		.catch(error => {
			captureErrorSentry({
				section: SentrySections.AUTHENTICATION,
				event: SentryEvents.REQUEST_OTP_ERROR,
				error,
				extra: {
					payload: body
				}
			})
			if (error.response.data.errors) {
				res = { detail: error.response.data.errors[0].msg }
			} else {
				res = { detail: error.response.data.detail.error }
			}
		})
	return res
}
